/*
 *  TTTech nerve-management-system-frontend
 *  Copyright(c) 2026. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */
import useAuthStore from '@/store/modules/pinia/auth';
import useUtilsStore from '@/store/modules/pinia/utils/_api_request_handler';
import router from '../../router';

/**
 * @description Handle mqtt offline event
 * @param {object} mqttInstance - mqtt client instance
 */
const handleOfflineEvent = (mqttInstance) => {
  const authStore = useAuthStore();
  const utilsStore = useUtilsStore();

  authStore.setServiceUnavailable({ service: 'Emq', isUnavailable: true });
  mqttInstance.logoutTimeout = setTimeout(async () => {
    await router.push({ name: 'Login' });
    await mqttInstance.disconnect();

    authStore.clearLocalStorage();
    // TODO what was this logic and do we need it again
    // await store.dispatch('node-tree/reset_state_to_default_values');
    utilsStore.showPermanentToast(true);
  }, authStore.inactivityTimeout);
};

/**
 * @description Handle mqtt on connect event
 * @param {object} mqttInstance - mqtt client instance
 */
const handleOnConnect = (mqttInstance) => {
  const authStore = useAuthStore();
  clearTimeout(mqttInstance.logoutTimeout);
  authStore.setServiceUnavailable({ service: 'Emq', isUnavailable: false });

  mqttInstance.subscribeTo('alwaysSubscribed');
  const session = localStorage.getItem('session');
  const { userId, sessionId } = JSON.parse(session);
  mqttInstance.subscribeTo('authUser', { userId, sessionId });

  const currentRoute = router.currentRoute.value;
  const isAccessTokensTabOpen =
    ['Add Edit User', 'User Settings'].includes(currentRoute?.name) && currentRoute?.query?.tab === 'tokens';

  if (isAccessTokensTabOpen) {
    mqttInstance.subscribeTo('accessTokens', { userId });
  }
};

export { handleOfflineEvent, handleOnConnect };
